var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-inner d-flex align-items-center justify-content-center",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"h100 d-flex flex-column justify-content-center lead",attrs:{"id":"main-wrapper"}},[_vm._v("\n      "+_vm._s(_vm.$t('message.Добро_пожаловать_в_панель_управления'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d3d61c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = null
// module chunks = 